import React from 'react'
import { Row, Col, Typography, Button, Card } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

const { Title, Text } = Typography

const DesktopSectionHeader = ({
  icon,
  title,
  subtitle,
  onBack,
  gradient = 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)'
}) => {
  return (
    <Card
      style={{
        marginBottom: '24px',
        borderRadius: '16px',
        background: gradient,
        border: 'none',
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
          pointerEvents: 'none'
        }}
      />
      <Row align='middle' justify='space-between' gutter={[16, 8]}>
        <Col flex='auto'>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              position: 'relative',
              zIndex: 1
            }}
          >
            {icon && (
              <div
                style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '28px',
                  color: 'white',
                  background: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(10px)',
                  flexShrink: 0,
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
                }}
              >
                <FontAwesomeIcon icon={icon} />
              </div>
            )}
            <div style={{ flex: 1 }}>
              <Title
                level={2}
                style={{
                  fontSize: '28px',
                  fontWeight: '700',
                  margin: '0 0 8px 0',
                  lineHeight: '1.2',
                  color: 'white',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}
              >
                {title}
              </Title>
              {subtitle && (
                <Text
                  style={{
                    fontSize: '16px',
                    color: 'rgba(255, 255, 255, 0.9)',
                    margin: '0',
                    lineHeight: '1.5'
                  }}
                >
                  {subtitle}
                </Text>
              )}
            </div>
          </div>
        </Col>

        {onBack && (
          <Col>
            <Button
              type='default'
              icon={<FontAwesomeIcon icon={faArrowLeft} />}
              onClick={onBack}
              style={{
                height: '44px',
                padding: '0 20px',
                borderRadius: '22px',
                fontWeight: '600',
                background: 'rgba(255, 255, 255, 0.2)',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                color: 'white',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)'
              }}
              size='large'
            >
              Back to Overview
            </Button>
          </Col>
        )}
      </Row>
    </Card>
  )
}

export default DesktopSectionHeader
